import React from "react";
import  { useState, useEffect } from 'react';
import './classes/RacingAgency.css';
import { configData } from "../config";
import { Helmet } from "react-helmet";
import Loading from './Loading';
import AgencySidebar from "./AgencySidebar";

const RacingAgency = () => {

    // const navigate = useNavigate();
    // const app_url = configData.APP_URL;
    const [isLoading, setIsLoading] = useState(true);
    const [racingDirectors, setRacingDirectors] = useState([]);
    const [blogData, setBlogData] = useState([]);
    const app_url = configData.APP_URL;

    useEffect(() => {
         const racingDirectors = [             
            {
                name: "Maikel Tsuji",
                image: "/basic/web/images/agent/picture-808956-1696447840.jpg",
                link: "/agent/maikel-tsuji-racing",
                bio: ["SMWW Racing Director"]
            },
              {
                name: "Dr. Lynn Lashbrook",
                image: "/basic/web/images/agent/picture-2742-1696447573.jpg",
                link: "/agent/lynn-lashbrook",
                bio: ["SMWW Agency President & Founder"]
            },
             
        ];
        setRacingDirectors(racingDirectors);        
    },[]);

    useEffect(() => {
        Promise.all([
            getagencynewslist() 
        ])
        .then(() => {
     
        setIsLoading(false);
        })
     
    },[]);

    async function getagencynewslist() {
        try {
            const response = await fetch(
                app_url+'smwwblog/getagencynewslist',
                {
                    method: "GET",
                    headers: {
                    'Content-Type': 'application/json',
                    },
                }
            )
            const responsedata = await response.json();
            if(responsedata.data.msg === "Success") {
                setBlogData(responsedata.data.result);
            }
        } catch (error) {
            console.error(error);
        }finally {
            // Set loading to false after fetch completes (success or error)
        }
    } 

    // const handleClick = (continent) => {
    //     navigate('/continents/'+continent+'/scouts');
    // };
    
    
    return (
        <>
       {isLoading ? (
            <Loading />
        ) : ( 
            <div id="racing-agency-banner-main">
            <div className="sports_agent_career_banner jobs_in_sports_banner" style={{"display":"inline-block","width":"100%"}}>
            <img className="medium_sized_image desktop-baseball-banner-img ban-img" src="/basic/web/images/agent/racing_agency.png" style={{"width":"100%"}}/>
            <img className="medium_sized_image desktop-soccer-banner-img mobile_ban_img" src="/basic/web/images/agent/mobile_racing.png" style={{"width":"100%"}}/>
          <div
            className="img_descp"
            style={{
                color: "white",
                position: "absolute",
                marginTop: "-21%",
                marginLeft: "27.5%",
                textShadow: "2px 2px 8px black, 0 0 25px black",
                filter: "drop-shadow(2px 2px 0px black)"
            }}
            >
            <h1
                className="h1_img_descp"
                style={{
                fontSize: "3.8vw",
                fontWeight: "bold"
                }}
            >
                SMWW Racing Agency
            </h1>

            <h2
                className="h2_img_descp"
                style={{
                fontSize: "2.24vw"
                }}
            >
                An extensive network of Agent Advisors <br />
                 representing drivers throughout the world.
            </h2>
            </div>

            </div>
  
            <div id="main" className="racing-agency-main">
                <Helmet><title>SMWW Racing Agency</title></Helmet>
                <div className="left racing-agency-left">
                    <div className="view-content">
                    <h2>Racing Directors</h2>
                    <div className="item-list mentors-wrapper">
                    <ul>
                        {/* Desktop Wrapper */}
                        <div className="des_sports_wrapper">
                        {racingDirectors.map((director, index) => (
                            <li
                            key={index}
                            className={`views-row views-row-${index + 1} ${
                                index % 2 === 0 ? "views-row-odd" : "views-row-even"
                            } ${index === 0 ? "views-row-first" : ""} ${
                                index === racingDirectors.length - 1 ? "views-row-last" : ""
                            }`}
                            >
                            <div className="views-field views-field-picture">
                                <div className="field-content">
                                <img
                                    className="lazyloaded"
                                    width="193"
                                    height="158"
                                    src={director.image}
                                    alt={director.name}
                                />
                                </div>
                            </div>

                            <div className="views-field views-field-field-last-name">
                                <div className="field-content">
                                <a href={director.link}>{director.name}</a>
                                </div>
                            </div>

                            <div className="views-field views-field-field-mentor-biography text">
                                <div className="field-content">
                                <ul>
                                    {director.bio.map((item, i) => (
                                    <li key={i}>{item}</li>
                                    ))}
                                </ul>
                                </div>
                            </div>
                            </li>
                        ))}
                        </div>

                        {/* Mobile Wrapper */}
                        <div className="mob_sports_wrapper">
                        {racingDirectors.map((director, index) => (
                            <div
                            key={index}
                            className={index % 2 === 0 ? "mob_sports_wrapper_odd" : "mob_sports_wrapper_even"}
                            style={{ float: index % 2 === 0 ? "left" : "right", width: "49%" }}
                            >
                            <li
                                className={`sports_directors_li views-row views-row-${index + 1} ${
                                index % 2 === 0 ? "views-row-odd" : "views-row-even"
                                } ${index === 0 ? "views-row-first" : ""} ${
                                index === racingDirectors.length - 1 ? "views-row-last" : ""
                                }`}
                            >
                                <div className="views-field views-field-picture">
                                <div className="field-content">
                                    <img
                                    className="lazyloaded"
                                    width="193"
                                    height="158"
                                    src={director.image}
                                    alt={director.name}
                                    />
                                </div>
                                </div>

                                <div className="views-field views-field-field-last-name">
                                <div className="field-content">
                                    <a href={director.link}>{director.name}</a>
                                </div>
                                </div>

                                <div className="views-field views-field-field-mentor-biography text">
                                <div className="field-content">
                                    <ul>
                                    {director.bio.map((item, i) => (
                                        <li key={i}>{item}</li>
                                    ))}
                                    </ul>
                                </div>
                                </div>
                            </li>
                            </div>
                        ))}
                        </div>
                    </ul>
                    </div>

                </div>
                </div>
                <div className="center left-center">
                   <div className="racing-agency-center">
                        <h1>SMWW Racing Agency</h1>
                        <p><img className="imgfulli race-img1 lazyloaded" src="/basic/web/images/agent/racing1.jpg"  style={{"float": "right", "margin":"2px 9px"}}/>Sports Management Worldwide (SMWW) is one of the leading International Racing agencies. The SMWW’s team has over 40 years of experience with contract negotiation, endorsements, sponsorship and driver development. At SMWW, we represent drivers in all facets of motorsports including NASCAR, F1, Formula E, IndyCar, BTCC, NHRA, British GT, and more.</p>
                        <p>The racing department is headed up by Racing Agent John Print and supported by a Worldwide network of Agent Advisors.  The knowledge & experience of the team, combined with global contacts allow SMWW to be in a perfect position to represent the interests of professional race car drivers. All of our services are bespoke to meet the requirements of the client.</p>
                        <p><strong>Typical services for racing clients include (but not limited):</strong></p>
                        <ul className="service-list">
                        <li>Driving and Commercial Contract Negotiation & Re-negotiation</li>
                        <li>Young professionals advice and support</li>
                        <li>Career advice</li>
                        <li>Team search, selection, and introduction</li>
                        <li>Driver & Family Liaison and General Support</li>
                        <li>Driver Management</li>
                        <li>Driver Development</li>
                        <li>Motorsports Consulting</li>
                        <li>Professional preparation and support (physical and mental  – on and off the track)</li>
                        </ul>
                        <p>&nbsp;</p>
                        <p><strong>Our personal service means that we are always available to help you make the right decisions in your career.</strong></p>
                        <ul className="service-list">
                        <li>Personal Brand Management</li>
                        <li>Ongoing career advice and development assessments</li>
                        <li>Media Management & Training</li>
                        <li>Wealth Management</li>
                        <li>Sponsorship & Endorsements</li>
                        <li>Lifestyle Management</li>
                        </ul>
                        <p>&nbsp;</p>
                        <p>We also have a strong and continually growing network with tracks, raceteams, managers as well as SMWW Agent Advisor's around the globe. This widens the racing services we can offer to drivers.</p>
                        <p>&nbsp;</p>
                        <p>If you are a professional driver who is looking for representation, we look forward to discussing your career and the options available to you.</p>
                        <p>&nbsp;</p>
                                               
                        <div style={{
                            listStyle: "none",
                            boxSizing: "border-box",
                            margin: 0,
                            padding: 0,
                            border: 0,
                            fontFamily: "sans-serif",
                            fontSize: "14px",
                            backgroundColor: "rgb(246, 245, 245)",
                            color: "rgb(255, 0, 0)"
                            }}>
                            <em style={{
                                listStyle: "none",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: 0,
                                border: 0,
                                lineHeight: "18px"
                            }}>
                                For more information on our Driver Management service please complete our 
                            </em>
                            <span style={{color: "rgb(0, 0, 0)"}}> </span>
                            <a href="/lookingforagent.php" style={{
                                listStyle: "none",
                                boxSizing: "border-box",
                                margin: 0,
                                padding: 0,
                                border: 0,
                                color: "rgb(33, 61, 134)",
                                fontSize: "14px",
                                fontFamily: "inherit",
                                fontStyle: "inherit",
                                backgroundColor: "rgb(246, 245, 245)",
                                outline: 0,
                                verticalAlign: "baseline"
                            }}>
                                online application
                            </a>
                            <span style={{color: "rgb(0, 0, 0)"}}>. </span>
                            </div>
                           <p>
                        <a
                            className="reddbtnn"
                            href="/agents"
                            style={{
                            width: '80%',
                            textAlign: 'center',
                            backgroundImage: 'linear-gradient(rgb(254, 0, 0) 0%, rgb(182, 0, 0) 100%)',
                            backgroundColor: 'rgb(255, 255, 255)',
                            }}
                        >
                            VIEW OUR SPORTS AGENTS
                        </a>
                        </p>

                    </div>
                </div>
                <div className="right agent-domain-sports">
                   <AgencySidebar/>
                   <h2>SMWW Sports Agency News</h2>
                   <div className="agency_blog">
      <ul className="list-unstyled mb-0">

        {blogData.slice(0, 5).map((post, index) => (
          <div key={index}>
            <li
              style={{
                listStyleType: "none",
                listStyle: "outside none"
              }}
            >
              <a href={post.link}>
                <img src={post.image} alt={post.title} />
              </a>

              <p className="stwwt-post-title">
                <a className="post-para" href={post.link}>
                  {post.title}
                </a>
                <br />
                <a href={post.link}>
                  <span className="button mr-1 arrow">Read Article</span>
                </a>
              </p>
            </li>

            {/* Separator */}
            {index < blogData.slice(0, 5).length - 1 && <li className="sepline">&nbsp;</li>}
          </div>
        ))}

      </ul>
    </div>

                </div>
            </div>
            </div>
        )}
        </>
    );
};
export default RacingAgency;